import React from "react";
import styles from "./ExportButton.module.css";

interface ExportButtonProps {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
    loadingLabel?: string;
}

const DownloadIcon: React.FC = () => (
    <svg
        className={styles.icon}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
);

const ExportButton: React.FC<ExportButtonProps> = ({ label, onClick, disabled, loading, loadingLabel }) => (
    <button type="button" className={styles.button} onClick={onClick} disabled={disabled || loading}>
        <DownloadIcon />
        {loading && loadingLabel ? loadingLabel : label}
    </button>
);

export default ExportButton;
